import React from 'react'
import tw from 'twin.macro'
import { BwTableTooltip, BwTableTooltipContent, BwTableTooltipTrigger } from './tooltip'

type HighlightTermsProps = {
  text: string
  terms?: Array<{ term: string; definition: string }>
}

function Tooltip({ children, tooltip }) {
  return (
    <BwTableTooltip>
      <BwTableTooltipTrigger
        css={tw`relative! w-auto! inline-block! [span]:(p-0! border-dotted border-b-2 border-primaryBlue) hover:cursor-help`}
      >
        {children}
      </BwTableTooltipTrigger>
      <BwTableTooltipContent>{tooltip}</BwTableTooltipContent>
    </BwTableTooltip>
  )
}

export default function HighlightTerms({ text, terms }: HighlightTermsProps) {
  if (!terms || !terms.length) return <>{text}</>

  const processText = (): React.ReactNode => {
    const result: React.ReactNode[] = []
    let remainingText = text

    terms.forEach(({ term, definition }) => {
      const regex = new RegExp(term, 'gi')
      let match

      do {
        match = regex.exec(remainingText)
        if (match) {
          const [matchedTerm] = match
          const { index } = match

          // Add text before the match
          if (index > 0) {
            result.push(remainingText.substring(0, index))
          }
          // Add the wrapped match
          result.push(
            <Tooltip key={index} tooltip={definition}>
              {matchedTerm}
            </Tooltip>
          )
          // Update remaining text
          remainingText = remainingText.substring(index + matchedTerm.length)
        }
      } while (match !== null)
      result.push(remainingText)
    })

    return <>{result}</>
  }

  return <>{processText()}</>
}
